import { render, staticRenderFns } from "./downloadGame.vue?vue&type=template&id=c95f76e6&scoped=true"
import script from "./downloadGame.vue?vue&type=script&lang=js"
export * from "./downloadGame.vue?vue&type=script&lang=js"
import style0 from "./downloadGame.vue?vue&type=style&index=0&id=c95f76e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95f76e6",
  null
  
)

export default component.exports